import React from 'react'

import { Helmet } from 'react-helmet'

import NavbarInteractive from '../components/navbar-interactive'
import Footer from '../components/footer'
import './contact.css'

const Contact = (props) => {
  return (
    <div className="contact-container1">
      <Helmet>
        <title>Contactformulier 'Als je niets bent' - marjangerrits.nl</title>
        <meta
          name="description"
          content="Dubbelroman over de Tweede Wereldoorlog."
        />
        <meta
          property="og:title"
          content="Contactformulier 'Als je niets bent' - marjangerrits.nl"
        />
        <meta
          property="og:description"
          content="Dubbelroman over de Tweede Wereldoorlog."
        />
      </Helmet>
      <div className="contact-top-container">
        <NavbarInteractive rootClassName="navbar-interactiveroot-class-name22"></NavbarInteractive>
      </div>
      <div id="main-section" className="contact-main">
        <div className="contact-container2">
          <img
            alt="image"
            src="/cover%20dubbelroman%20web%20kleine%20rand-1200w.png"
            className="contact-thumbnail-boek1"
          />
          <span className="contact-text10">
            <span className="contact-text11">Als je niets bent</span>
            <br className="contact-text12"></br>
            <span className="contact-text13">Twee kanten van een oorlog</span>
            <br></br>
            <span>Uitgeverij Interpaco</span>
            <br></br>
            <span>ISBN: 978-90-835269-0-4</span>
            <br className="contact-text18"></br>
            <span>Aantal pagina’s: 304</span>
            <br className="contact-text20"></br>
            <span>Prijs: € 22,50</span>
            <br className="contact-text22"></br>
          </span>
          <a
            href="https://kampamersfoort.nl/product/als-je-niets-bent-twee-kanten-van-een-oorlog-marjan-gerrits/"
            target="_blank"
            rel="noreferrer noopener"
            className="contact-link1"
          >
            <div className="contact-bestelknop">
              <h3 className="contact-bestel1">
                <span>Bestel bij Kamp Amersfoort</span>
                <span>
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </span>
              </h3>
            </div>
          </a>
          <h3 className="contact-boekwinkel">of bij je favoriete boekwinkel</h3>
        </div>
        <div className="contact-container3">
          <img
            alt="image"
            src="/soft_cover_book_mockup-removebg-preview%20voor%20web-1000w.png"
            className="contact-thumbnail-boek2"
          />
          <button type="submit" className="contact-button1 button">
            <a
              href="https://kampamersfoort.nl/product/als-je-niets-bent-twee-kanten-van-een-oorlog-marjan-gerrits/"
              target="_blank"
              rel="noreferrer noopener"
            >
              <h3 className="contact-bestel2">
                <span>Bestel bij Kamp Amersfoort</span>
                <span>
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </span>
              </h3>
            </a>
            Bestel het boek
          </button>
        </div>
        <div className="contact-container4">
          <h3 className="contact-bestelmogelijkheden BlogTitel">
            Bestelmogelijkheden
          </h3>
          <h3 className="Dikgedrukt_tekst contact-text28">Optie 1</h3>
          <span className="contact-text29">
            <span>
              Een persoonlijk exemplaar van de auteur. Op verzoek kan het boek
              worden gesigneerd of voorzien van een persoonlijke boodschap.
            </span>
            <br className="Content"></br>
            <span>
              Kosten € 25,00 incl. € 2,50 bijdrage in de verzendkosten (binnen
              Nederland).
            </span>
            <br className="Content"></br>
            <span>
              Vul onderstaand formulier in. Je ontvangt vervolgens een betaallink per e-mail. Na betaling wordt het boek zo snel mogelijk naar je toegestuurd.
            </span>
            <br className="Content"></br>
            <br className="Content"></br>
          </span>
          <h4 className="Dikgedrukt_tekst contact-text38"> Optie 2</h4>
          <span className="contact-text39">
            <span>
              Kom langs in Castricum en haal het boek persoonlijk op (€ 22,50).
              Stuur me in dat
            </span>
            <br className="Content"></br>
            <span>
              geval een berichtje, dan krijg je mijn adres en zorg ik dat de
              koffie klaar staat.
            </span>
            <br></br>
            <br></br>
          </span>
          <h4 className="Dikgedrukt_tekst contact-text45">Optie 3</h4>
          <span className="contact-text46">
            <span>
              Bestel het boek bij je favoriete boekhandel of breng een bezoek
              aan Kamp Amersfoort en koop het daar.
            </span>
            <br></br>
            <br></br>
            <span>
              <span
                dangerouslySetInnerHTML={{
                  __html: ' ',
                }}
              />
            </span>
          </span>
          <h4 className="Dikgedrukt_tekst contact-text51">Optie 4</h4>
          <span className="contact-text52">
            <span>
              Bestel het boek bij de blauwe man met de ronde buik:
              <span
                dangerouslySetInnerHTML={{
                  __html: ' ',
                }}
              />
            </span>
            <a
              href="https://www.bol.com/nl/nl/p/als-je-niets-bent/9300000229534701"
              target="_blank"
              rel="noreferrer noopener"
              className="contact-link3"
            >
              Bol
            </a>
          </span>

          <br></br>
          <h4 className="Dikgedrukt_tekst contact-text75">Optie 5</h4>
          <span className="contact-text76">
            <span>Liever een e-book? Deze is te koop bij </span>
            <a
              href="https://www.bol.com/nl/nl/p/als-je-niets-bent/9300000229534701"
              target="_blank"
              rel="noreferrer noopener"
              className="contact-link3"
            >
              Bol
            </a>
            <span> en staat ook bij </span>
            <a
              href="https://www.kobo.com/nl/nl/plus"
              target="_blank"
              rel="noreferrer noopener"
              className="contact-link5"
            >
              Kobo Plus
            </a>.
            <br></br>
          </span>
        </div>
        <iframe
          src="https://sibforms.com/serve/MUIFAN_bsO6mrPdaXBCtF-OvYlFk3-0nmE-94qTaYMenuxNrZEATY5faZyCPrGOD_cRgU8GykOQfKvl_mnlm0oqi-jYZgt-3hHn_nNGUXVx5woz34_GpeYc6ZMJyX5giBNAjwS7MIig1PA4vPZYupWeu3Vgkz37DtcbJ6qx4D0MTCZ4EHXGdVETWjwRhYe8ty9mEaE4sgbvwqOaP"
          className="contact-iframe"
        ></iframe>
        <h2 className="contact-titel-reserveer-het-boek Titel">
          Reserveer het boek hier
        </h2>
        <form
          action="https://formsubmit.co/marjangerrits@gmail.com"
          method="POST"
          enctype="application/x-www-form-urlencoded"
          className="contact-form"
        >
          <div className="contact-formulier">
            <input
              type="text"
              name="Naam"
              required
              placeholder="Naam"
              autoComplete="name"
              className="contact-naam input"
            />
            <input
              type="text"
              name="Email"
              required
              placeholder="Email"
              autoComplete="email"
              className="contact-email input"
            />
            <input
              type="text"
              name="Bericht"
              placeholder="Bericht"
              className="contact-bericht input"
            />
            <div className="contact-container5">
              <input
                type="checkbox"
                name="Reserveren"
                value="da"
                className="contact-checkbox-boek-reserveren"
              />
              <span className="contact-text54">
                <span>
                  Ik wil alvast het boek &apos;Als je niets bent&apos;
                  reserveren! 
                </span>
                <span>Je krijgt een mailtje zodra het boek er is.</span>
                <br></br>
              </span>
            </div>
            <button type="submit" className="contact-button2 button">
              Verstuur
            </button>
          </div>
        </form>

        <span className="contact-text65">
          <span className="Content">
            Ik vind het leuk te horen wat je van het boek vindt. 
          </span>
          <span className="Content">Stuur gerust een mailtje naar</span>
          <a href="mailto:marjangerrits@gmail.com?subject=dubbelroman Als je niets bent">
            {' '}
            marjangerrits@gmail.com
          </a>
          <span className="Content">
            .
            <span
              dangerouslySetInnerHTML={{
                __html: ' ',
              }}
            />
          </span>
          <br className="Content"></br>
          <span className="Content">
            Ook als je vragen of opmerkingen hebt.
            <span
              dangerouslySetInnerHTML={{
                __html: ' ',
              }}
            />
          </span>
        </span>
        <span className="contact-text71 Content">
          Werkt het formulier niet of stuur je liever een mailtje? Dat kan naar
          marjangerrits@gmail.com.
        </span>
      </div>
      <Footer rootClassName="footerroot-class-name22"></Footer>
    </div>
  )
}

export default Contact
